/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Defectp21Inputs */



/**
* | output |
* | --- |
* | "Right/bottom pump fault" |
*
* @param {Ahu_History_Key_Defectp21Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_defectp21 = /** @type {((inputs?: Ahu_History_Key_Defectp21Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Defectp21Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/bottom pump fault")
	return /** @type {LocalizedString} */ ("Défaut pompe droite/basse")
});
export { ahu_history_key_defectp21 as "ahu_history_key_defectP2" }